import { Circle, CheckCircle } from "@phosphor-icons/react";
import { dateTimeLabel } from "../lib/format";

const FLOW = [
  "ADJUDICADO", "TRANSPORTISTA_EN_CAMINO", "EN_ORIGEN",
  "CARGA_RECOGIDA", "EN_TRASLADO", "ENTREGADO", "COMPLETADO",
];
const LABELS = {
  ADJUDICADO: "Transportista asignado",
  TRANSPORTISTA_EN_CAMINO: "Transportista en camino",
  EN_ORIGEN: "En origen",
  CARGA_RECOGIDA: "Carga recogida",
  EN_TRASLADO: "En traslado",
  ENTREGADO: "Entregado",
  COMPLETADO: "Completado",
};

function fmt(iso) {
  if (!iso) return null;
  const v = dateTimeLabel(iso);
  return v === "—" ? null : v;
}

export function StatusTimeline({ status, history = [] }) {
  if (status === "CANCELADO") {
    return (
      <div className="rounded-xl bg-red-50 border border-red-200 px-4 py-3 text-sm font-semibold text-red-700" data-testid="timeline-cancelled">
        Servicio cancelado
      </div>
    );
  }
  const currentIdx = FLOW.indexOf(status);
  const timeOf = (s) => {
    const e = [...(history || [])].reverse().find((h) => h.status === s);
    return fmt(e?.at);
  };
  return (
    <ol className="flex items-start" data-testid="status-timeline">
      {FLOW.map((s, i) => {
        const done = i < currentIdx;
        const active = i === currentIdx;
        const t = timeOf(s);
        return (
          <li key={s} className="flex-1 flex flex-col items-center text-center relative min-w-0">
            {i < FLOW.length - 1 && (
              <span className={`absolute top-3 left-1/2 w-full h-0.5 ${i < currentIdx ? "bg-[#FF5A36]" : "bg-zinc-200"}`} />
            )}
            <span className="relative z-10 bg-white">
              {done ? (
                <CheckCircle size={24} weight="fill" className="text-[#FF5A36]" />
              ) : active ? (
                <span className="w-6 h-6 rounded-full bg-[#FF5A36] flex items-center justify-center animate-pulse">
                  <span className="w-2 h-2 rounded-full bg-white" />
                </span>
              ) : (
                <Circle size={24} className="text-zinc-300" />
              )}
            </span>
            <div className="mt-2 px-1">
              <div className={`text-[11px] leading-tight font-medium ${done || active ? "text-[#0F1115]" : "text-zinc-400"}`}>{LABELS[s]}</div>
              {t && <div className="text-[10px] text-zinc-400 mt-0.5 whitespace-nowrap">{t}</div>}
            </div>
          </li>
        );
      })}
    </ol>
  );
}
